import React from 'react'
import ProposalCreate from '../Components/Dao/Proposalcreate';


const Proposalcreate = () => {
  return (
    <>
        <ProposalCreate />
    </>
  )
}

export default Proposalcreate;